export default __webpack_public_path__ + "static/media/MSmile.b4b3d4d4.svg";